<script setup>
import { customCss } from '@/views/experimental/table-view/quasar.js';
import { useStyleTag } from '@vueuse/core';
import { ref, onMounted, onUnmounted } from 'vue';
const { id, css, load, unload } = useStyleTag(customCss, { id: 'nabuto' });

onUnmounted(() => {
  unload();
});
</script>

<template>
  <div class="px-4 overflow-hidden flex flex-1 flex-col relative h-full w-full">
    <!-- <vs-popup
      fullscreen
      title="Automated Reports"
      v-if="popupActive4"
      :active.sync="popupActive4"
    >
    <UserSettingsReports></UserSettingsReports>
  </vs-popup> -->

    <vs-popup
      style="z-index: 999999"
      fullscreen
      title="Upload Fuel Receipt"
      v-if="popupActive2"
      :active.sync="popupActive2"
    >
      <add-receipt-popup
        @exit="closeModal"
        :fleets="unitSelection"
        :fmsSelection="fmsSelection"
      ></add-receipt-popup>
    </vs-popup>
    <vs-popup
      style="z-index: 999999"
      fullscreen
      title="Upload Toll Receipt"
      v-if="popupActive3"
      :active.sync="popupActive3"
    >
      <add-receipt-toll-popup
        @exit="closeModal"
        :fleets="unitSelection"
        :fmsSelection="fmsSelection"
      ></add-receipt-toll-popup>
    </vs-popup>
    <vs-popup
      style="z-index: 999999"
      title="Additional Configurations"
      :active.sync="configPopup"
    >
      <vs-td
        v-if="
          selection.type == 'Maintenance Log' ||
          selection.type == 'Maintenance Cost' ||
          selection.type == 'Tire Cost Analysis'
        "
      >
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Status of Records
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <v-select
              :options="['Upcoming', 'Delayed', 'Completed']"
              placeholder="Status of Records"
              v-model="configuration.fleetMTTypes2"
              :multiple="true"
              :clearable="false"
            >
            </v-select>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Types of Records
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <v-select
              :options="['Document', 'Service', 'Tire']"
              placeholder="Types of Records"
              v-model="configuration.fleetMTTypes"
              :multiple="true"
              :clearable="false"
            >
            </v-select>
          </vs-col>
        </vs-row>
      </vs-td>
      <vs-td
        v-if="
          selection.type == 'History' ||
          selection.type == 'Temperature' ||
          selection.type == 'History - Watch'
        "
      >
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Time Interval
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.interval"
              label="Minutes"
              :step="1"
            />
          </vs-col>
        </vs-row>
        <!--        <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" vs-w="4" >
                       Speed Filter
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-w="5" >
                       <v-select  :options="['>=','<=','=']"  v-model="configuration.speedType" />
                </vs-col>
                    <vs-col vs-type="flex"  vs-justify="center" vs-w="3">
                         <vs-input v-model="configuration.speedLimit" />
                </vs-col>
              </vs-row> -->
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Speed Filter
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="5">
            <v-select
              :options="['>=', '<=', '=']"
              v-model="configuration.speedType"
            />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="3">
            <vs-input v-model="configuration.speedLimit" />
          </vs-col>
        </vs-row>
      </vs-td>
      <vs-td v-if="selection.type == 'Fatigue Driving'">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Mandatory Break Time (mins)
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.mandatoryBreakTime"
              label="minutes"
              :step="10"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Fatigue Driving Time (mins)
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.fatigueDrivingTime"
              label="minutes"
              :step="10"
            />
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Idling Accepted As Break ?
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-switch v-model="configuration.idlingAcceptedAsBreak">
            </vs-switch>
          </vs-col>
        </vs-row>
      </vs-td>
      <vs-td v-if="selection.type == 'Summary'">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Idling Timer
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.idleTimer"
              label="minutes"
              :step="10"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Parking Timer
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.parkTimer"
              label="minutes"
              :step="10"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Trip Timer
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.tripTimer"
              label="minutes"
              :step="10"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Idling Wastage
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.idlingWastagePct"
              label="Pct %"
              :step="10"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Fuel Price (RM)
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.idlingWastagePrice"
              label="Price RM"
              :step="1"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Idling Wastage Liter per Hour
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.idlingWastageLtr"
              label="Liter/hour"
              :step="1"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Include Fuel Analysis
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-switch v-model="configuration.includeFuelAnalysis">
              <span slot="yes">YES</span>
              <span slot="no">NO</span>
            </vs-switch>
          </vs-col>
        </vs-row>
      </vs-td>
      <vs-td v-if="selection.type == 'Alarm'">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Overspeeding Timer
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.speedTimer"
              label="seconds"
              :step="30"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Overspeeding Limit
          </vs-col>

          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.speedLimit"
              label="kph"
              :step="5"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Idling Timer
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.idleTimer"
              label="minutes"
              :step="10"
            />
          </vs-col>
        </vs-row>
      </vs-td>
      <vs-td v-if="selection.type == 'Input'">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Input Timer
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.inputTimer"
              label="seconds"
              :step="30"
            />
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            PTO Analysis
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-switch v-model="configuration.agriAnalysis">
              <span slot="yes">YES</span>
              <span slot="no">NO</span>
            </vs-switch>
          </vs-col>
        </vs-row>
      </vs-td>

      <vs-td v-if="selection.type == 'Fuel'">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Fuel Price (RM)
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="6">
            <vs-input v-model="configuration.refuelPrice" type="number" />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="2">
            <vs-button
              size="small"
              radius
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-edit"
            ></vs-button>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Refuel Volume
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.refuelVolume"
              label="Litres"
              :step="10"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Refuel Timer
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.refuelTimer"
              label="Minutes"
              :step="5"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Siphon Volume
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.siphonVolume"
              label="Litres"
              :step="10"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Siphon Timer
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.siphonTimer"
              label="Minutes"
              :step="5"
            />
          </vs-col>
        </vs-row>

        <!--        <vs-row>
                        <vs-col vs-type="flex" vs-justify="center" vs-w="4" >
                       Speed Filter
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-w="5" >
                       <v-select  :options="['>=','<=','=']"  v-model="configuration.speedType" />
                </vs-col>
                    <vs-col vs-type="flex"  vs-justify="center" vs-w="3">
                         <vs-input v-model="configuration.speedLimit" />
                </vs-col>
              </vs-row> -->

        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-w="4">
            Refuel Weight Density
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-w="8">
            <vs-input-number
              v-model="configuration.refuelWeightDensity"
              label="kg/Litre"
            />
          </vs-col>
        </vs-row>
      </vs-td>
      <vs-td
        v-if="
          (selection.type == 'POI' || selection.type == 'POI - Watch') &&
          configuration.poiSelectionAll != undefined
        "
      >
        <vs-row>
          <vs-col vs-w="4">
            <b>Time Spent Inside POI</b>
          </vs-col>
          <vs-col vs-w="8">
            <vs-input-number
              v-model="configuration.timeInsidePOI"
              label="Minutes"
              :step="1"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="4">
            <b>Legacy Mode</b>
          </vs-col>
          <vs-col vs-w="8">
            <vs-switch v-model="configuration.poiLegacyMode"> </vs-switch>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-w="4">
            <b>All POI Selected</b>
          </vs-col>
          <vs-col vs-w="8">
            <vs-switch v-model="configuration.poiSelectionAll">
              <template #yes>YES</template>
              <template #no>NO</template>
            </vs-switch>
          </vs-col>
        </vs-row>
        <br /><br />
        <vs-row v-if="configuration.poiSelectionAll == false">
          <vs-col vs-w="4">
            <b>Select POI</b>
          </vs-col>
          <vs-col vs-w="8">
            <ejs-multiselect
              id="multiselect4"
              :dataSource="mapPOIData"
              v-model="configuration.poiSelection"
              :fields="poiFields"
              popupHeight="400px"
              width="300px"
              mode="CheckBox"
              enableGroupCheckBox="true"
              showDropDownIcon="true"
              allowFiltering="true"
              filterType="contains"
              filterBarPlaceholder="Search"
              showSelectAll="true"
              placeholder="Select POI"
            ></ejs-multiselect>
          </vs-col>
        </vs-row>
      </vs-td>

      <br /><br /><br />
    </vs-popup>
    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>
    <vs-row style="height: 56px">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <v-select
          placeholder="Report Type"
          :options="useReportsList"
          class="mb-4 md:mb-0"
          v-model="selection.type"
          :clearable="false"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
        <DatePicker
          lang="en"
          placeholder="Select Timerange"
          range
          type="datetime"
          format="DD/M/YYYY H:mm:ss"
          input-class="form-control"
          v-model="selection.timeRange"
          :disabled-date="(date) => date >= new Date()"
          id="datetimepicker"
        >
          <i class="glyphicon glyphicon-th" slot="calendar-icon" />
        </DatePicker>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="3"
        class="relative"
      >
        <!-- {{ selection.units }} -->
        <!-- <ejs-multiselect
          id="multiselect"
          :dataSource="unitSelection"
          v-model="selection.units"
          :fields="fields"
          popupHeight="400px"
          mode="CheckBox"
          enableGroupCheckBox="true"
          showDropDownIcon="true"
          allowFiltering="true"
          filterType="contains"
          filterBarPlaceholder="Search"
          showSelectAll="true"
          placeholder="Select Assets"
          :filtering="filtering"
        ></ejs-multiselect> -->
        <AssetsSelect
          @selected="
            (v) => {
              // $emit('selected', v);
              selection.units = v;
            }
          "
          :style="{ width: `356px` }"
          ref="assetSelect"
          :filtering="filtering"
          :f="fields"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-button :disabled="isLoading" @click="getReportData" size="small">{{
          buttonMessage
        }}</vs-button>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <vs-button
          radius
          color="primary"
          type="gradient"
          icon-pack="feather"
          icon="icon-settings"
          @click="openConfigPanel()"
        ></vs-button>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
        <!-- <vs-button
          radius
          color="primary"
          type="gradient"
          icon-pack="feather"
          icon="icon-send"
          @click="openAutomatedPanel()"
        ></vs-button> -->
      </vs-col>
    </vs-row>
    <template>
      <div
        style="
          top: calc(56px + 1rem);
          right: 2rem;
          z-index: 2;
          position: absolute;
          width: fit-content;
          height: fit-content;
        "
        class="flex gap-3"
      >
        <vs-dropdown
          v-for="btn in extraButton"
          :key="btn.label"
          vs-custom-content
          @click="extraButtonClick(btn.click)"
          ><vs-button
            v-if="btn.if"
            class="whitespace-no-wrap"
            color="primary"
            size="small"
            type="gradient"
            >{{ btn.label }}
          </vs-button>
          <vs-dropdown-menu v-if="btn.label == 'Playback'">
            <vs-dropdown-item v-for="n in playbackList" :key="n.id">
              <a
                class="a-icon whitespace-no-wrap"
                href.prevent
                @click="historyPlayback(n.unitId)"
              >
                {{ n.assetName }}
              </a>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </template>
    <div class="w-full flex-1 overflow-hidden">
      <reports-content
        ref="reports-content"
        v-if="loaded == true && experimentalApi"
        :reportsData="reportsData"
        :timeRange="selection.timeRange"
        :uid="userInfo.uid"
        :units="selection.units"
        :assetNameArr="assetNameArr"
        :type="loadedReport"
        :component="reportsComponent"
        :showAnalysisButton="configuration.agriAnalysis"
        :summarySeries="summarySeries"
        @setModalView="setModalView"
      >
        <template #reportsPdfExport="{ data }">
          <reportsPdfExport
            v-if="modalData"
            :reportData="modalData"
            :currentTable="data.currentTable"
            :reportsComponent="data.reportsComponent"
            :timeRange="data.timeRange"
            :units="data.units"
            :activeTab="data.activeTab"
          />
        </template>
        <template #[modalView]="{ data }">
          <component
            :is="modalView"
            :data="modalData"
            :reportsContent="data.reportsContent"
            :reportData="data.reportData"
            :currentTable="data.currentTable"
            :reportsComponent="data.reportsComponent"
            :timeRange="data.timeRange"
            :uid="userInfo.uid"
            :userInfo="userInfo"
            :units="data.units"
            :geoPOIData="geoPOIData"
            :fleets="unitSelection"
            :refuelVolume="configuration.refuelVolume"
            :refuelTimer="configuration.refuelTimer"
            :configuration="configuration"
          />
        </template>
      </reports-content>
    </div>
  </div>
</template>

<script>
import AddReceiptPopup from '../maintenance/AddReceiptPopup.vue';
import AddReceiptTollPopup from '../maintenance/AddReceiptTollPopup.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import ReportsContent from './ReportsContent.vue';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { Query, Predicate } from '@syncfusion/ej2-data';
import * as reports from './reports/index';
import * as modalComponents from './reports/modal-view/index';
import reportsPdfExport from '../../components/reports-table/ReportsPdfExport.vue';
import { reportsList } from './reports/config/reportsList';
import UserSettingsReports from '../pages/user-settings/UserSettingsReports.vue';

import AssetsSelect from '@/views/experimental/map-view/AssetsSelect.vue';

var today = new Date();

export default {
  computed: {
    playbackList() {
      return this.unitSelection.filter((item) =>
        this.selection.units.includes(item.unitId),
      );
    },
    extraButton() {
      return [
        {
          if: this.selection.type === 'Fuel Receipt',
          label: 'Upload Fuel Receipt',
          click: 'addNewData',
        },
        {
          if: this.selection.type === 'Toll Receipt',
          label: 'Upload Toll Receipt',
          click: 'addNewData2',
        },
        {
          if:
            this.reportsComponent &&
            (this.reportsComponent[0].label == 'History' ||
              this.reportsComponent[0].label == 'History - Watch'),
          label: 'Playback',
        },
      ];
    },
    reportsData() {
      return [
        this.reportData,
        this.reportData2,
        this.reportData3,
        this.reportData4,
        this.reportData5,
      ];
    },
    reportsComponent() {
      if (this.loadedReport) {
        const getItemLabel = (item) =>
          item.label ? item.label.toLowerCase() : item.name;
        const foundObject = reportsList.find(
          (item) => getItemLabel(item) === this.loadedReport.toLowerCase(),
        );
        return reports[foundObject.name]();
      }
    },
    experimentalApi() {
      // return this.refactored.includes(this.loadedReport);// Function to check if the item has a label, and if not, compare with name
      // unfortunately vue-cli v4 use webpack 4 which didn't support ES6
      // const getItemLabel = (item) => item.label ?? item.name;
      if (this.loadedReport) {
        const getItemLabel = (item) =>
          item.label ? item.label.toLowerCase() : item.name;
        const foundObject = reportsList.find(
          (item) => getItemLabel(item) === this.loadedReport.toLowerCase(),
        );
        return foundObject ? (foundObject.enable ? true : false) : false;
      }
      // unfortunately vue-cli v4 use webpack 4 which didn't support ES6
      // return foundObject?.enable ?? false;
    },
    useReportsList() {
      let result = [...this.userInfo.access.reports];
      let found = [];
      // merge the selection
      const getItemLabel = (item) =>
        item.label ? item.label.toLowerCase() : item.name;
      result.forEach((main) => {
        const foundObject = reportsList.find(
          (item) => getItemLabel(item) === main.toLowerCase(),
        );
        if (foundObject) {
          found.push(foundObject.name);
        }
      });
      reportsList.forEach((item) => {
        if (!found.includes(item.name)) {
          result.push(
            item.label
              ? item.label
              : `${item.name.charAt(0).toUpperCase()}${item.name.slice(1)}`,
          );
        }
      });

      return result;
    },
  },
  data() {
    return {
      refactored: [
        'Alarm',
        'History',
        'Input',
        'Mileage',
        'Notification',
        'Fuel Receipt',
      ],
      modalData: null,
      modalView: '',
      configPopup: false,
      geoPOIData: JSON.parse(localStorage.getItem('geoPOIData')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      reportConfiguration:
        JSON.parse(localStorage.getItem('reportConfiguration')) || null,
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      fmsSelection: [],
      fields: { groupBy: 'assetGroup', text: 'assetName', value: 'unitId' },
      selection: {
        timeRange: [
          new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            0,
            0,
            0,
          ),
          new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            23,
            59,
            59,
          ),
        ],
        type: '',
        units: [],
      },
      devices: [],
      loaded: false,
      loadedReport: null,
      isLoading: false,
      buttonMessage: 'Proceed',
      reportData: [],
      reportData2: [],
      popupActive2: false,
      popupActive3: false,
      popupActive4: false,
      reportData3: [],
      reportData4: [],
      reportData5: [],
      json_fields: {},
      json_fields2: {},
      json_fields3: {},
      json_fields4: {},
      summarySeries: [],
      assetNameArr: [],
      configuration: null,
      poiFields: { text: 'name', value: 'id' },
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
    };
  },
  watch: {
    configPopup: function (val) {
      var self = this;
      if (self.configPopup == false) {
        var uInfo = self.configuration;
        localStorage.setItem('reportConfiguration', JSON.stringify(uInfo));
      }
    },
  },
  methods: {
    setModalView(v, data) {
      if (data) {
        this.modalData = null;
        setTimeout(() => {
          this.modalData = data;
        }, 0);
      }
      if (v != 'reportsPdfExport') {
        this.modalView = v;
      }
    },
    updateUserRefuelPriceSetting() {
      var self = this;
      self.$http
        .patch(
          'admin/users-fuelprice/' +
            self.userInfo.uid +
            '/' +
            Number(self.configuration.refuelPrice),
          {},
        )
        .then(function (response) {
          self.isLoading = true;
          if (response.status == 200 && response.data.success) {
            var uInfo = self.userInfo;
            uInfo.fuelPrice = Number(self.configuration.refuelPrice);
            localStorage.setItem('userInfo', JSON.stringify(uInfo));
            self.isLoading = false;
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated user settings.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else {
            self.isLoading = false;
            if (response.data.error) {
              return self.$vs.notify({
                title: 'Error',
                text: 'Could not update user settings.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
            } else {
              return self.$vs.notify({
                title: 'Error',
                text: 'Could not update user settings.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
            }
          }
        })
        .catch(function (error) {
          self.isLoading = false;
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update user settings.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    filtering: function (args) {
      var self = this;
      var searchData = self.unitSelection;
      var query = new Query();
      let predicate = new Predicate('assetName', 'contains', args.text, true);
      predicate = predicate.or('assetGroup', 'contains', args.text, true);
      query = args.text != '' ? query.where(predicate) : query;

      args.updateData(searchData, query);
    },
    openConfigPanel() {
      this.configPopup = true;
    },
    openAutomatedPanel() {
      this.popupActive4 = true;
    },
    getReportData() {
      var self = this;

      self.loaded = false;
      self.isLoading = true;
      self.buttonMessage = 'Fetching data..Kindly wait';
      var units = [];
      var index = 0;
      var length = self.selection.units.length;
      if (self.selection.type != 'Notification') {
        if (self.selection.units == '' || self.selection.units.length == 0) {
          self.$vs.notify({
            title: 'Error',
            text: 'Select at least one asset',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });

          self.isLoading = false;
          return (self.buttonMessage = 'Proceed');
        }
      }

      if (self.selection.type == '') {
        self.$vs.notify({
          title: 'Error',
          text: 'Select Report Type',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });

        self.isLoading = false;
        return (self.buttonMessage = 'Proceed');
      }
      if (self.selection.timeRange == '' || self.selection.timeRange == null) {
        self.$vs.notify({
          title: 'Error',
          text: 'Select timerange',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });

        self.isLoading = false;
        return (self.buttonMessage = 'Proceed');
      }

      var type = self.selection.type;
      var timeRange = self.selection.timeRange;

      if (timeRange == '' || timeRange[0] == null) {
        timeRange = 'All';
      }

      self.$http
        .post('report/table', {
          timeRange: timeRange,
          type: type,
          accountId: self.userInfo.accountId,
          uid: self.userInfo.uid,
          subAccountName: self.userInfo.subAccountName,
          units: self.selection.units,
          unitSelection: self.unitSelection,
          configuration: self.configuration,
          geoPOIData: self.geoPOIData,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.loadedReport = self.selection.type;
            self.reportData = response.data.reportData;
            self.assetNameArr = response.data.assetNameArr;
            self.summarySeries = response.data.summarySeries;
            self.reportData2 = response.data.reportData2;
            self.reportData3 = response.data.reportData3;
            self.reportData4 = response.data.reportData4;
            self.reportData5 = response.data.reportData5;
            self.loaded = true;
            self.isLoading = false;
            self.buttonMessage = 'Proceed';
          } else {
            self.loaded = true;
            self.isLoading = false;
            self.buttonMessage = 'Proceed';
            if (response.data.error) {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
            } else {
              self.$vs.notify({
                title: 'Error',
                text: 'Try again later.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
              });
            }
          }
        })
        .catch(function (error) {
          self.loaded = true;
          self.isLoading = false;
          self.buttonMessage = 'Proceed';
          self.$vs.notify({
            title: 'Error',
            text: 'Try again later.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    addNewData() {
      this.popupActive2 = true;
    },
    closeModal() {
      var self = this;
      self.popupActive2 = false;
    },
    addNewData2() {
      this.popupActive3 = true;
    },
    closeModal2() {
      var self = this;
      self.popupActive3 = false;
    },
    getFleets() {
      const self = this;
      self.$http
        .get(`fleetsAllByUserFms/${self.userInfo.uid}`, {})
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.fmsSelection = response.data.fmsSelection;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
    extraButtonClick(v) {
      if (!v) return;
      this[v]();
    },
    async historyPlayback(v) {
      let ref = this.$refs['reports-content'];
      if (!ref) return;
      let data = await this.getPlayback(v);
      if (!data) return;
      ref.slotName = 'PlayBackV2';
      ref.pdfModal = true;
      this.setModalView('PlayBackV2', {
        data: {
          onReady: function (self) {
            return new Promise((resolve) => {
              self.loadMap = true;
              self.onReadyData.title = `Playback - ${data.assetName}`;
              self.selected = data;
              resolve(true);
            });
          },
        },
      });
    },
    async getPlayback(v) {
      this.isLoading = true;
      try {
        let response = await this.$http.post('singleUnitPlayback3', {
          timeRange: this.selection.timeRange,
          configuration: {
            speedType: '',
            speedLimit: 0,
          },
          platform: 'Web',
          uid: undefined,
          geoPOIData: this.geoPOIData,
          units: [v],
        });
        if (response.status == 200 && response.data.success) {
          this.isLoading = false;
          let data = response.data;
          const matchingObject = this.unitSelection.find(
            (item) => item.unitId === v,
          );
          data.assetName = matchingObject ? matchingObject.assetName : null;
          data.timeRange = this.selection.timeRange;
          return data;
        } else {
          console.log(response);
          this.$vs.notify({
            title: 'Error',
            text: 'No data available',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        this.$vs.notify({
          title: 'Error',
          text: 'No data available',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
    },
  },
  components: {
    ...modalComponents,
    reportsPdfExport,
    ReportsContent,
    vSelect,
    DatePicker,
    MultiSelectPlugin,
    Query,
    Predicate,
    AddReceiptPopup,
    AddReceiptTollPopup,
    UserSettingsReports,
    AssetsSelect,
  },
  mounted() {
    var self = this;
    self.getFleets();
    if (this.$route.params.assetName && this.$route.params.assetId) {
      let index = this.unitSelection.findIndex(
        (val) => val.assetId == this.$route.params.assetId,
      );
      if (index != -1) {
        this.selection.units.push(this.unitSelection[index].unitId);
      }
    }
    if (self.reportConfiguration) {
      self.configuration = self.reportConfiguration;
      if (!self.configuration.mandatoryBreakTime) {
        self.configuration.poiSelectionAll = true;
        self.configuration.poiSelection = [];
        self.configuration.mandatoryBreakTime = 30;
        self.configuration.fatigueDrivingTime = 240;
        self.configuration.idlingAcceptedAsBreak = true;
      }
      if (
        !self.configuration.timeInsidePOI ||
        self.configuration.timeInsidePOI == undefined
      ) {
        self.configuration.timeInsidePOI = 5;
      }
      if (
        !self.configuration.poiLegacyMode ||
        self.configuration.poiLegacyMode == undefined
      ) {
        self.configuration.poiLegacyMode = false;
      }
    } else {
      self.configuration = {
        poiSelectionAll: true,
        poiSelection: [],
        fleetMTTypes: ['Document', 'Service', 'Tire'],
        fleetMTTypes2: ['Upcoming', 'Delayed', 'Completed'],
        idleTimer: 0,
        parkTimer: 0,
        tripTimer: 0,
        interval: 0,
        speedType: '',
        speedLimit: 90,
        speedTimer: 60,
        refuelPrice: 3.35,
        refuelVolume: 10,
        refuelTimer: 60,
        siphonVolume: 10,
        siphonTimer: 15,
        showHidden: false,
        inputTimer: 0,
        agriAnalysis: false,
        refuelWeightDensity: 1.0,
        idlingWastagePct: 80,
        idlingWastageLtr: 3,
        idlingWastagePrice: 3.35,
        includeFuelAnalysis: false,
        mandatoryBreakTime: 30,
        fatigueDrivingTime: 240,
        idlingAcceptedAsBreak: true,
        timeInsidePOI: 5,
        poiLegacyMode: false,
      };
    }
  },
};
</script>

<style>
.v-select {
  min-width: 180px;
}

@import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css';
@import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
</style>
